import { useState } from 'react';

export const SORT_BY_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc'
};

const useTableSortBy = (defaultKey, defaultDir = SORT_BY_DIRECTIONS.DESC) => {
  const [tableSortBy, setTableSortBy] = useState({
    key: defaultKey,
    dir: defaultDir
  });

  const onChange = (key, dir) =>
    setTableSortBy(prevState => ({
      ...prevState,
      key,
      ...(!!dir && { dir })
    }));

  return {
    ...tableSortBy,
    onChange
  };
};

export default useTableSortBy;
